import React, { useEffect, useRef, useState } from 'react'
import { useField } from 'formik'
import { FormHelperText, OutlinedTextFieldProps } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import * as Styled from './InputField.styled'
import { transparentBorderStyle } from './InputField.styled'
import { Duration } from '../../../utils/domain/Duration'
import { Colors } from 'styles'

interface TextFieldFieldProps extends OutlinedTextFieldProps {
  name: string
  label?: string
  classes?: any
  fullWidth?: boolean
  style?: {
    fontSize?: number
    fontWeight?: number
    backgroundColor?: string
  }
  darkMode?: boolean
  accept?: string
  onChangeFile?: (file: File) => Promise<void>
}

const MAX_FILE_SIZE = 1000000 // 1 MB

const ImageInput: React.FC<TextFieldFieldProps> = ({
  name,
  label,
  classes,
  fullWidth,
  style,
  children,
  darkMode,
  accept,
  onChangeFile,
  placeholder,
  helperText,
  error,
  ...props
}) => {
  const [_field, meta, helpers] = useField(name)

  const imageInputRef = useRef<any>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const clickInputButton = () => {
    document.getElementById(name)?.click()
  }

  return (
    <Styled.Wrapper fullWidth={fullWidth}>
      {label && (
        <Styled.StyledLabel htmlFor={name} darkMode={darkMode}>
          {label}
          <Styled.ContentWrapper>{children}</Styled.ContentWrapper>
        </Styled.StyledLabel>
      )}
      <Styled.InputFileWrapper
        darkMode
        onClick={() => {
          if (!isLoading) {
            clickInputButton()
          }
        }}
      >
        {_field.value?.name ?? placeholder}
        <input
          type="file"
          style={{ display: 'none' }}
          id={name}
          accept={accept}
          ref={imageInputRef}
          onChange={async (e) => {
            helpers.setError(null)

            setIsLoading(true)

            if (!e.target.files) return
            const file = e.target.files.item(0)
            if (!file) return

            if (file.size > MAX_FILE_SIZE) {
              alert(
                `Essa imagem excede o tamanho limite de imagens de 1 MB.
                 Tamanho: ${(file.size / 1000000).toPrecision(3)} MB.`,
              )
              setIsLoading(false)
              return
            }

            if (onChangeFile) {
              await onChangeFile(file)
            }

            setIsLoading(false)
          }}
        />
        {helperText && (
          <FormHelperText error={error}>{helperText}</FormHelperText>
        )}
        <Styled.UploadIcon fill={Colors.GREY[200]} />
      </Styled.InputFileWrapper>
      {isLoading && <Styled.LoadingSpinner size={24} />}
    </Styled.Wrapper>
  )
}

export default withStyles(transparentBorderStyle)(ImageInput)
